import { fieldOfficeActions } from "../_constants/actionConstants";

// Field Office lists are normalized by districts (int)
const fieldOfficesInitialState = {
  fetching: false,
  error: null,
};

export const reducer = (state = fieldOfficesInitialState, action) => {
  switch (action.type) {
    case fieldOfficeActions.FETCH_FIELD_OFFICES:
      return { ...state, fetching: true };

    case fieldOfficeActions.FETCH_FIELD_OFFICES_FULFILLED:
      return {
        ...state,
        fetching: false,
        [action.district]: action.fieldOfficeList,
      };

    case fieldOfficeActions.FETCH_FIELD_OFFICES_REJECTED:
      return { ...state, fetching: false, error: action.payload };

    case fieldOfficeActions.ADD_FIELD_OFFICE:
      return { ...state, fetching: true };

    case fieldOfficeActions.ADD_FIELD_OFFICE_FULFILLED:
      return {
        ...state,
        fetching: false,
        [action.district]: action.fieldOfficeList,
      };

    case fieldOfficeActions.ADD_FIELD_OFFICE_REJECTED:
      return { ...state, fetching: false, error: action.payload };

    default:
      return state;
  }
};
